module.exports = __webpack_public_path__ + "static/media/prstLogo.fbb4fc7c.jpg";